export const getBlob = (url) =>
  fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.onerror = reject
          reader.readAsDataURL(blob)
        })
    )

export default getBlob

// Usage:
// componentDidMount() {
//   const profileUrl = '/library/imgs/staff/' + this.props.user.profile_img
//   getBlob(profileUrl).then((dataUrl) => {
//     this.setState({ blob: dataUrl, loading: false })
//   })
// }
